import {
  call,
  put,
  all,
  spawn,
  takeEvery,
  takeLatest,
  debounce,
} from 'redux-saga/effects';
import request from 'utils/request';
import {
  FETCH_EASY_SPLIT_CONFIG_URL,
  VENDOR_DATA_BY_ID_URL,
} from 'constants/url';
import { showToast } from '../Toast/actions';
import {
  disableLoaderAction,
  saveConfigurationsAction,
  saveStaticSplitStatusAction,
} from './actions';
import {
  CREATE_SPLIT_SCHEME,
  CREATE_SPLIT_SCHEME_URL,
  // DELETE_SPLIT_SCHEME,
  GET_ALL_TERMINAL_ID,
  GET_ALL_TERMINAL_ID_URL,
  GET_STATIC_SPLIT_STATUS,
  GET_VENDOR_BY_ID,
  SEARCH_CONFIGURATIONS,
  SEARCH_SPLIT_SCHEME,
} from './constants';
import { restructureData } from './helper';

export function* getStaticSplitStatus() {
  try {
    const { url, method } = FETCH_EASY_SPLIT_CONFIG_URL;
    const response = yield call(request, url, { method });
    yield put(saveStaticSplitStatusAction(response));
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* searchConfigurations({ data }) {
  try {
    const { options: reqOptions, cb } = data;
    const { url, method } = SEARCH_SPLIT_SCHEME;
    const options = { method, queryString: reqOptions || {} };
    const response = yield call(request, url, options);
    if (cb) {
      if (response.content.length === 0) cb('success');
      else cb('error');
    } else yield put(saveConfigurationsAction(response.content));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* createSchemeConfiguration({ data: { cb, ...data } }) {
  try {
    const { url, method } = CREATE_SPLIT_SCHEME_URL;
    const options = {
      method,
      body: JSON.stringify(data),
    };
    yield call(request, url, options);
    cb('success');
  } catch (err) {
    cb('error');
    yield put(showToast(err));
  }
}

// export function* deleteSchemeConfiguration({ data: { onClose, ...data } }) {
//   try {
//     const { url, method } = CREATE_SPLIT_SCHEME_URL;
//     const options = {
//       method,
//       body: JSON.stringify(data),
//     };
//     yield call(request, url, options);
//     yield put(showToast('Scheme deleted successfully'));
//     onClose();
//   } catch (err) {
//     yield put(showToast(err));
//   }
// }

export function* getTerminalId({ data }) {
  try {
    const { options: reqOptions, cb } = data;
    const { url, method } = GET_ALL_TERMINAL_ID_URL;
    // const updatedUrl = url.replace('$id$', merchantId);
    const options = {
      method,
      queryString: reqOptions || {},
    };
    const response = yield call(request, url, options);
    cb(restructureData(response));
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getVendorById({ data: { vendorId, cb } }) {
  try {
    const { url, method } = VENDOR_DATA_BY_ID_URL;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    yield call(request, updatedUrl, { method });
    cb('success');
  } catch (err) {
    cb('error');
  }
}

export function* getStaticSplitStatusSaga() {
  yield takeEvery(GET_STATIC_SPLIT_STATUS, getStaticSplitStatus);
}

export function* searchConfigurationsSaga() {
  yield takeEvery(SEARCH_CONFIGURATIONS, searchConfigurations);
}

export function* createSchemeConfigurationSaga() {
  yield takeLatest(CREATE_SPLIT_SCHEME, createSchemeConfiguration);
}

// export function* deleteSchemeConfigurationSaga() {
//   yield takeLatest(DELETE_SPLIT_SCHEME, deleteSchemeConfiguration);
// }

export function* getTerminalIdSaga() {
  yield debounce(500, GET_ALL_TERMINAL_ID, getTerminalId);
}

// export function* getTerminalIdSaga() {
//   yield takeLatest(GET_ALL_TERMINAL_ID, watchSearch);
// }

export function* getVendorByIdSaga() {
  yield takeLatest(GET_VENDOR_BY_ID, getVendorById);
}

// Individual exports for testing
export default function* splitSchemeConfigurationSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getStaticSplitStatusSaga,
    searchConfigurationsSaga,
    createSchemeConfigurationSaga,
    // deleteSchemeConfigurationSaga,
    getTerminalIdSaga,
    getVendorByIdSaga,
  ];
  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
